import React, { useEffect, useState } from 'react';
import { Col, Row, Image } from "react-bootstrap";
import Container from 'react-bootstrap/Container';
import Logo from '../../assets/logo.png';
import Background from '../../assets/background.jpg';
import { useTranslation } from 'react-i18next';
import { Route } from "react-router-dom";

import { Dropdown, Form } from "react-bootstrap";
import { TranslationsOptionsAbr } from "../../translations";
import storageService from "../../services/storage.service";
import { setDefaultLocale } from "react-datepicker";
import i18n from 'i18next';

const backgroundImageStyle = {
  height: '100vh',
  backgroundImage:`url(${Background})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat'
};


const LoginLayout = ({ children }) => {
  const { t } = useTranslation();
  const [idiomDefault, setIdiomDefault] = useState(storageService.getIdiom());

  // Verifica e define o idioma quando o componente é montado
  useEffect(() => {
    const currentLanguage = storageService.getIdiom();
    if (currentLanguage) {
      i18n.changeLanguage(currentLanguage);
    }
  }, [i18n]);

  const onChangeLanguage = (e) => {
    setIdiomDefault(e.target.value);
    setDefaultLocale(e.target.value.replaceAll('-', ''));
    i18n.changeLanguage(e.target.value, (err, t) => {
      if (err) return console.log('something went wrong loading', err);
      else {
        storageService.setIdiom(e.target.value);
        //window.location.reload();
      }
    });
  };

  return (
    <div id='background-login' style={backgroundImageStyle}>
      {/* Seletor de Idioma no canto superior direito */}
      <div className="language-selector">
        <Form.Select
          onChange={onChangeLanguage}
          value={idiomDefault}
          style={{ backgroundColor: '#000038', color: 'white', border: '1px solid #000038' }} // Estilo inline para o seletor de idioma
          
        >
          {TranslationsOptionsAbr.map((t, index) => (
            <option key={index} value={t.shortName}>
              {t.name}
            </option>
          ))}
        </Form.Select>
      </div>

      <Container fluid>
        <Row className="justify-content-center align-items-center">
          <Col sm={12} md={4} lg={3} className="d-flex align-items-center justify-content-start" style={{ paddingRight: '48px', height: '390px' }}>
            <div className="m-3">
              <Image src={Logo} fluid />

            </div>
          </Col>
          <div className="vertical-divider custom-row" ></div>
          <Col  sm={12} md={4} lg={3} className="d-flex align-items-center justify-content-center" >
            <div className="login-form">
              <Row>
                <h2>
                  {t("PAGE_LOGIN.TITLE")}<br />
                </h2>
              </Row>
              <Row>
                {children}
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const LoginLayoutRoute = ({ component: Component, ...rest }) => {
  return (
    <Route {...rest} render={matchProps => (
      <LoginLayout>
        <Component {...matchProps} />
      </LoginLayout>
    )} />
  )
};

export default LoginLayoutRoute;